import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_409: DocMigration = {
  maxSchemaVersion: "0.0.409",
  description: "Add DetailType to Detail Annotations",
  apply(json: any) {
    if (json.annotation) {
      for (const annotationId in json.annotation) {
        const annotation = json.annotation[annotationId];
        if (annotation.type === "DETAIL") {
          annotation.detailType = "INLINE_IMAGE";
        }
      }
    }

    return json;
  },
};

export default migration_0_0_409;
